/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Quick_ToolsInputs */

const en_control_quick_tools = /** @type {(inputs: Control_Quick_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your next move`)
};

const zh_control_quick_tools = /** @type {(inputs: Control_Quick_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速工具`)
};

/**
* | output |
* | --- |
* | "Choose your next move" |
*
* @param {Control_Quick_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_quick_tools = /** @type {((inputs?: Control_Quick_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Quick_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_quick_tools(inputs)
	return zh_control_quick_tools(inputs)
});
export { control_quick_tools as "control.quick_tools" }